
<template>
  <v-container fluid>
    <v-layout align-center justify-center column class="relative-position">
      <v-flex xs12 sm3 md2 class="absolute" style="top: 0;right: 0;">
        <v-btn outline fab small color="primary" @click.native="loadData">
          <v-icon>mdi-refresh</v-icon>
        </v-btn>
      </v-flex>
      <v-flex xs12 sm3 md2 class="relative-position">
        <v-select v-model="departamento" :items="departamentos" label="Descripcion" item-text="label" item-value="value" @input="loadData" />
      </v-flex>

      <v-flex xs12>
        <v-layout align-center justify-center row wrap>
          <v-flex xs12 md6 align-center justify-center fill-height>
            <v-layout id="tecnicosComparativo-legend" ref="tecnicosComparativo-legend" align-center justify-center row />
            <v-layout align-center justify-center>
              <bar-chart :data="tecnicosComparativo.data" :options="tecnicosComparativo.opciones" :width="500" :height="300" class="item-flex relative-center max-width-500 max-height-300" />
            </v-layout>
          </v-flex>

          <v-flex xs12 md6 align-center justify-center fill-height>
            <v-layout align-center justify-center row class="relative-position pl-3">
              <span id="tecnicosTrabajo-legend" ref="tecnicosTrabajo-legend" class=" mb-2" />
              <span class="absolute mb-2" style="right: 0;">
                <v-menu v-model="tecnicosTrabajo.menu" :close-on-content-click="false" nudge-bottom="5" offset-y left>
                  <template v-slot:activator="{ on }">
                    <v-btn :loading="tecnicosTrabajo.loading" color="primary"
                           outline flat icon v-on="on"
                    >
                      <v-icon>settings</v-icon>
                    </v-btn>
                  </template>
                  <v-list>
                    <v-list-tile>
                      <v-date v-model="tecnicosTrabajo.desde" :max="tecnicosTrabajo.hasta" label="Desde" hide-details class="pt-0 mt-1 mb-0" style="width: 130px" />
                    </v-list-tile>
                    <v-list-tile>
                      <v-date v-model="tecnicosTrabajo.hasta" :min="tecnicosTrabajo.desde" label="Hasta" hide-details class="pt-0 mt-3 mb-0" style="width: 130px" />
                    </v-list-tile>
                  </v-list>
                </v-menu>
              </span>
            </v-layout>
            <v-layout align-center justify-center>
              <bar-chart :data="tecnicosTrabajo.data" :options="tecnicosTrabajo.opciones" :width="500" :height="300" class="item-flex relative-center max-width-500 max-height-300" />
            </v-layout>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import BarChart from 'components/chartjs/bar.js'
import VDate from '@/components/VDate'
import moment from 'moment'

export default {
  components: { BarChart, VDate },
  data () {
    return {
      onActiveDelay: null,
      total: 0,
      totalLastYear: 0,
      totalCerradasHoy: 0,
      recuentoTecnicoHoy: [],
      recuentoTecnicoLastYear: [],
      recuentoTecnicoPendientes: [],
      recuentoTecnicoCerradasHoy: [],
      recuentoTecnicoTiempo: [],
      departamento: 2,
      departamentos: [
        { value: 1, label: 'HARDWARE' },
        { value: 2, label: 'SOFTWARE' },
        { value: 3, label: 'DESARROLLO' },
        { value: 4, label: 'SISTEMAS' }
      ],
      tecnicosComparativo: { data: [], opciones: [] },
      tecnicosTrabajo: { data: [], opciones: [], menu: false, loading: false, desde: moment(), hasta: moment() }
    }
  },
  metaInfo: { title: 'Estadísticas - Sopheo' },
  watch: {
    recuentoTecnicoHoy (value) {
      if (value) {
        this.total = value.reduce((a, b) => {
          return a + b.Count
        }, 0)
      }
    },
    recuentoTecnicoCerradasHoy (value) {
      if (value) {
        this.totalCerradasHoy = value.reduce((a, b) => {
          return a + b.Count
        }, 0)
      }
    },
    recuentoTecnicoLastYear (value) {
      if (value) {
        this.totalLastYear = value.reduce((a, b) => {
          return a + b.Count
        }, 0)
      }
    },
    'tecnicosTrabajo.menu' (value) {
      if (!value) { this.getTecnicosTrabajo() }
    }
  },
  created () {
    this.onActiveDelay = moment()
    this.loadData()
    this.$on('legendGenerated', ({ legend, idContainer }) => this.legendGenerated(legend, idContainer))
  },
  onActive () {
    this.loadData()
  },
  destroyed () {
    this.$off('legendGenerated')
  },
  methods: {
    loadData () {
      this.getTecnicosComparativo()
      this.getTecnicosTrabajo()
    },
    legendGenerated (legend, idContainer) {
      if (this.$refs[idContainer]) { this.$refs[idContainer].innerHTML = legend }
    },
    async getTecnicosComparativo () {
      this.recuentoTecnicoHoy = []
      this.recuentoTecnicoLastYear = []
      await this.axios
        .get(`${this.$apiUrl('recuentoTecnicoEstado')}?departamento=${this.departamento}&fecha=${moment().format('YYYY-MM-DD')}`,
          { headers: { 'Content-Type': 'application/json' } })
        .then(({ data }) => {
          this.recuentoTecnicoHoy = data || []
        })
        .catch(() => { })

      await this.axios
        .get(`${this.$apiUrl('recuentoTecnicoEstado')}?departamento=${this.departamento}&fecha=${this.lastYear(moment()).format('YYYY-MM-DD')}`,
          { headers: { 'Content-Type': 'application/json' } })
        .then(({ data }) => {
          this.recuentoTecnicoLastYear = data || []
        })
        .catch(() => { })

      this.tecnicosComparativo.data = {
        labels: this.recuentoTecnicoHoy.map((item) => { return item.Nombre }),
        datasets: [{
          type: 'bar',
          borderColor: '#333',
          borderWidth: 0,
          label: 'Hoy',
          data: this.recuentoTecnicoHoy.map((item) => { return item.Count }),
          backgroundColor: '#1E88E5'
        }, {
          borderColor: '#333',
          type: 'bar',
          borderWidth: 0,
          label: this.lastYear().format('DD/MM/YYYY'),
          data: this.recuentoTecnicoLastYear.map((item) => { return item.Count }),
          backgroundColor: '#5E35B1'
        } ]
      }
      let yAxesMax = Math.max(...this.tecnicosComparativo.data.datasets[0].data) + 1
      if (this.tecnicosComparativo.data.datasets[1] && yAxesMax < Math.max(...this.tecnicosComparativo.data.datasets[1].data) + 1) {
        yAxesMax = Math.max(...this.tecnicosComparativo.data.datasets[1].data) + 1
      }

      this.tecnicosComparativo.opciones = {
        responsive: true,
        maintainAspectRatio: true,
        legend: {
          display: false
        },
        legendIdContainer: 'tecnicosComparativo-legend',
        legendCallback: (chart) => {
          var text = []
          var datasets = chart.data.datasets
          text.push(`<span tabindex="0" class="v-chip theme--light white--text" style="background-color:${datasets[0].backgroundColor}">
              <span class="v-chip__content">${datasets[0].label}
              <div class="v-avatar avatar-right ml-2" style="background-color: #0003;">${this.total}</div>
            </span></span>`)
          text.push(`<span tabindex="0" class="v-chip theme--light white--text" style="background-color:${datasets[1].backgroundColor}">
              <span class="v-chip__content">${datasets[1].label}
              <div class="v-avatar avatar-right ml-2" style="background-color: #0003;">${this.totalLastYear}</div>
            </span></span>`)
          return text.join('')
        },
        scales: {
          yAxes: [{
            scaleLabel: {
              display: true,
              labelString: '# Incidencias'
            },
            // offset: true,
            ticks: {
              min: 0,
              max: yAxesMax,
              stepSize: yAxesMax > 15 ? yAxesMax / 4 : 1,
              autoSkip: true
            }
          }],
          xAxes: [{
            ticks: {
              min: 0,
              stepSize: 1,
              autoSkip: false,
              maxRotation: 25 // angle in degrees
            }
          }]
        }
      }
    },
    async getTecnicosTrabajo () {
      this.recuentoTecnicoPendientes = []
      this.recuentoTecnicoCerradasHoy = []
      this.recuentoTecnicoTiempo = []
      this.tecnicosTrabajo.loading = true
      /* await this.axios
        .get(`${this.$apiUrl('recuentoTecnicoEstado')}?departamento=${this.departamento}&fecha=${null}&estados=P&estados=U&estados=N`,
          { headers: { 'Content-Type': 'application/json' } })
        .then(({ data }) => {
          this.recuentoTecnicoPendientes = data || []
        })
        .catch(() => { }) */
      await this.axios
        .get(`${this.$apiUrl('recuentoTecnicoEstado')}?departamento=${this.departamento}&fecha=${moment().format('YYYY-MM-DD')}&estados=C`,
          { headers: { 'Content-Type': 'application/json' } })
        .then(({ data }) => {
          this.recuentoTecnicoCerradasHoy = data || []
        })
        .catch(() => { })

      await this.axios
        .get(`${this.$apiUrl('recuentoTecnicoTiempo')}?departamento=${this.departamento}
            &desde=${moment(this.tecnicosTrabajo.desde).format('YYYY-MM-DD')}&hasta=${moment(this.tecnicosTrabajo.hasta).format('YYYY-MM-DD')}`,
        { headers: { 'Content-Type': 'application/json' } })
        .then(({ data }) => {
          this.recuentoTecnicoTiempo = data || []
        })
        .catch(() => { })

      this.tecnicosTrabajo.data = {
        labels: this.recuentoTecnicoTiempo.map((item) => { return item.Nombre }),
        datasets: [{
          yAxisID: 'y-axis-2',
          type: 'line',
          fill: false,
          borderWidth: 1,
          radius: 5,
          borderColor: '#F4511E',
          backgroundColor: '#F4511E',
          data: this.recuentoTecnicoTiempo.map((item) => item.Count),
          label: 'Horas'
        },
        {
          yAxisID: 'y-axis-1',
          borderWidth: 0,
          backgroundColor: '#1E88E5',
          data: this.recuentoTecnicoCerradasHoy.map((item) => { return item.Count }),
          label: 'Cerradas Hoy'
        } /* {
            yAxisID: 'y-axis-1',
            borderWidth: 0,
            borderColor: '#333',
            backgroundColor: '#5E35B1',
            data: this.recuentoTecnicoPendientes.map((item) => { return item.Count }),
            label: 'Pendientes'
          }, */ ]
      }

      let yAxesMax2 = Math.max(...this.tecnicosTrabajo.data.datasets[0].data)
      yAxesMax2 += 15

      let yAxesMax = Math.max(...this.tecnicosTrabajo.data.datasets[1].data) + 1
      if (this.tecnicosTrabajo.data.datasets[1] && yAxesMax < Math.max(...this.tecnicosTrabajo.data.datasets[1].data) + 1) {
        yAxesMax = Math.max(...this.tecnicosTrabajo.data.datasets[1].data) + 1
      }

      this.tecnicosTrabajo.opciones = {
        responsive: true,
        maintainAspectRatio: true,
        tooltips: {
          mode: 'index',
          callbacks: {
            label: (t, d) => {
              let tooltip = d.datasets[t.datasetIndex].label + ': '
              if (t.datasetIndex === 0) {
                tooltip += window.toTotalTime(t.yLabel)
              } else tooltip += t.yLabel
              return tooltip
            }
          }
        },
        legend: {
          display: false
        },
        legendIdContainer: 'tecnicosTrabajo-legend',
        legendCallback: (chart) => {
          let text = []
          let datasets = chart.data.datasets
          let desdeHasta = (this.tecnicosTrabajo.desde === this.tecnicosTrabajo.hasta) ? `(${moment(this.tecnicosTrabajo.hasta).format('DD/MM/YY')})`
            : `(${moment(this.tecnicosTrabajo.desde).format('DD/MM/YY')} - ${moment(this.tecnicosTrabajo.hasta).format('DD/MM/YY')})`
          text.push(`<span tabindex="0" class="v-chip theme--light white--text" style="background-color:${datasets[1].backgroundColor}">
              <span class="v-chip__content">${datasets[1].label}
              <div class="v-avatar avatar-right ml-2" style="background-color: #0003;">${this.totalCerradasHoy}</div>
            </span></span>`)

          text.push(`<span tabindex="0" class="v-chip theme--light white--text" style="background-color:${datasets[0].backgroundColor}">
              <span class="v-chip__content">${datasets[0].label} ${desdeHasta}
              
            </span></span>`)
          return text.join('')
        },
        scales: {
          yAxes: [{
            display: true,
            position: 'left',
            id: 'y-axis-1',
            scaleLabel: {
              display: true,
              labelString: '# Incidencias'
            },
            ticks: {
              min: 0,
              max: yAxesMax,
              stepSize: yAxesMax > 15 ? yAxesMax / 4 : 1,
              autoSkip: true
            }
          }, {
            scaleLabel: {
              display: true,
              labelString: 'Horas Trabajadas'
            },
            type: 'linear',
            position: 'right',
            id: 'y-axis-2',
            ticks: {
              autoSkip: true,
              suggestedMax: yAxesMax2,
              // stepSize: 3.6e+6, // 3600000
              beginAtZero: true,
              callback: value => {
                return window.toTotalTime(value)
              }
            },
            gridLines: {
              color: 'rgba(0, 0, 0, 0)'
            }
          }],
          xAxes: [{
            ticks: {
              min: 0,
              stepSize: 1,
              autoSkip: false,
              maxRotation: 25 // angle in degrees
            }
          }]
        }
      }

      this.tecnicosTrabajo.loading = false
    },
    moment () {
      return moment()
    },
    lastYear (date) {
      if (!date) { date = moment() }
      return moment().subtract(1, 'year')
        .isoWeek(date.isoWeek())
        .isoWeekday(date.isoWeekday())
    }
  }
}
</script>

<style scoped>
</style>
